// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pLwB","largestCol":"styles_largestCol__21C7D","smallestCol":"styles_smallestCol__3Gypi"};